import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbModal, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';

import { AuraAuthService } from '@digital-platform/aura-authentication/services';
import { IdentityService } from '@digital-platform/rs-auth/services';
import { AccountDropdownBoxComponent } from '@digital-platform/rs-header/ui';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';
import { FeatureFlagService } from '@digital-platform/util-feature-flags/services';

@UntilDestroy()
@Component({
  selector: 'digital-platform-mobile-nav-toggle',
  templateUrl: './mobile-nav-toggle.component.html',
  styleUrls: ['./mobile-nav-toggle.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    NgbPopoverModule,
    AccountDropdownBoxComponent,
    RouterLink,
  ],
})
export class MobileNavToggleComponent {
  @Input() mobileNavOpen = false;
  @Output() toggle = new EventEmitter<void>();

  public identityService = inject(IdentityService);
  private auraAuthService = inject(AuraAuthService); // @AURA
  public accountDropdownOpened = false;

  constructor(private modalService: NgbModal) {}

  openMenuOrNavigate() {
    if (this.identityService.isLoggedIn) {
      this.accountDropdownOpened = true;
      const modalRef = this.modalService.open(AccountDropdownBoxComponent, {
        fullscreen: 'xl',
      });
      modalRef.dismissed.subscribe(() => {
        this.accountDropdownOpened = false;
      });
      modalRef.componentInstance.styles = {
        padding: '32px',
        'background-color': '#F6F6F6',
      };
      modalRef.componentInstance.isMobile = true;
    } else {
      this.auraAuthService.login();
    }
  }

  onToggle(): void {
    this.toggle.emit();
  }
}
